import { render, staticRenderFns } from "./PnrForm.vue?vue&type=template&id=5b57865a&"
import script from "./PnrForm.vue?vue&type=script&lang=js&"
export * from "./PnrForm.vue?vue&type=script&lang=js&"
import style0 from "./PnrForm.vue?vue&type=style&index=0&id=5b57865a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports